/* =============================================================================
   HIDDEN MULTIPLIERS - Preorder Page Animations
   Phase 5 - Scroll animations and interactive enhancements
   ============================================================================= */

(function() {
  'use strict';

  // Respect reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Don't add animation class, content stays visible naturally
    return;
  }

  // Enable animations by adding class to body
  document.body.classList.add('js-animations');

  /* ---------------------------------------------------------------------------
     Scroll-triggered Animations using Intersection Observer
     --------------------------------------------------------------------------- */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -80px 0px'
  };

  // Observer for sections
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Optionally unobserve after animation
        // sectionObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observer for cards (with stagger effect)
  const cardObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  // Observe all sections except hero
  document.querySelectorAll('.preorder-section:not(.preorder-hero)').forEach(section => {
    sectionObserver.observe(section);
  });

  // Observe cards for staggered animation
  document.querySelectorAll('.testimonial-card, .metric-card, .chapter-card, .pricing-tier').forEach(card => {
    cardObserver.observe(card);
  });

  /* ---------------------------------------------------------------------------
     Sticky CTA Visibility
     --------------------------------------------------------------------------- */
  const heroSection = document.querySelector('.preorder-hero');
  const stickyCTA = document.querySelector('.preorder-sticky-cta');
  const finalCTA = document.querySelector('.preorder-final-cta');

  if (heroSection && stickyCTA) {
    let ticking = false;

    const updateStickyVisibility = () => {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const finalCTATop = finalCTA ? finalCTA.getBoundingClientRect().top : Infinity;
      const viewportHeight = window.innerHeight;

      // Show sticky CTA when scrolled past hero, hide when final CTA is visible
      if (heroBottom < 0 && finalCTATop > viewportHeight) {
        stickyCTA.classList.add('is-visible');
      } else {
        stickyCTA.classList.remove('is-visible');
      }

      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateStickyVisibility);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check
    updateStickyVisibility();
  }

  /* ---------------------------------------------------------------------------
     Initialize - Make hero visible immediately
     --------------------------------------------------------------------------- */
  const hero = document.querySelector('.preorder-hero');
  if (hero) {
    hero.classList.add('is-visible');
  }

})();
